import { Link } from "react-router-dom";
import { Droplets, Sun, Leaf, ArrowRight } from "lucide-react";
import { IMAGES } from "../data/site";

/* eslint-disable react/no-unescaped-entities */

const points = [
  { icon: Droplets, title: "Cut water bills 50–60%", desc: "Replace thirsty St. Augustine with native, adapted, drought-tolerant planting." },
  { icon: Sun, title: "Austin Water rebates", desc: "Qualify for up to $3,000 in Austin Water Landscape Conversion rebates. We handle paperwork." },
  { icon: Leaf, title: "Beautiful year-round", desc: "Salvia, agave, muhly grass, Texas sage and live oaks designed for Hill Country light." },
];

export default function XeriscapeFeature() {
  return (
    <section data-testid="xeriscape-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-emerald-700">
            Our most-requested service
          </div>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-black tracking-tighter text-stone-900 leading-[1.02]">
            Xeriscape <span className="text-emerald-700">Austin.</span>
            <br /> The smarter Texas yard.
          </h2>
          <p className="mt-5 text-stone-600 text-lg leading-relaxed max-w-2xl">
            Xeriscape isn't a "cactus yard" — it's the modern Austin, TX landscape: native plants,
            drip irrigation, decomposed granite paths, stone borders and just enough turf in the
            places that matter. Texan Strong Builds designs xeriscape yards that lower water bills,
            boost curb appeal and end Saturday mowing.
          </p>

          <div className="mt-9 grid sm:grid-cols-3 gap-5">
            {points.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="border border-stone-200 p-5">
                <Icon size={22} className="text-emerald-700" strokeWidth={2.2} />
                <div className="mt-3 font-bold text-stone-900">{title}</div>
                <p className="mt-1 text-sm text-stone-600 leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/xeriscape" className="btn-primary" data-testid="xeriscape-learn-cta">
              See xeriscape designs <ArrowRight size={18} />
            </Link>
            <Link to="/contact" className="btn-outline" data-testid="xeriscape-quote-cta">
              Free xeriscape quote
            </Link>
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="grid grid-cols-2 gap-3">
            <img
              src={IMAGES.xeriscape1}
              alt="Austin xeriscape with aloe vera and native plants"
              className="aspect-[3/4] w-full object-cover border border-stone-200"
              loading="lazy"
            />
            <div className="flex flex-col gap-3 pt-10">
              <img
                src={IMAGES.xeriscape2}
                alt="Dense drought tolerant succulent landscaping in Austin"
                className="aspect-square w-full object-cover border border-stone-200"
                loading="lazy"
              />
              <div className="bg-stone-900 text-white p-5">
                <div className="font-display text-3xl font-black tracking-tight">58%</div>
                <div className="text-xs uppercase tracking-[0.18em] text-stone-400 mt-1">
                  Avg. water savings on TSB xeriscape conversions
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
